import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { UpdateFilteredQuotesDebounced, ClearSearch } from "./BookOfMindTools";

export function BookOfMindSearch() {
    const [searchText, setSearchText] = React.useState("");

    ShareState(
        ESharedFunction.BookOfMindSearch_searchText,
        searchText,
        setSearchText
    );

    return (
        <FormInput
            type="text"
            onChange={(event) => {
                const searchText = event.target.value;
                setSearchText(searchText);
                UpdateFilteredQuotesDebounced(searchText);
            }}
            onFocus={ClearSearch}
            onClear={ClearSearch}
            placeholder="Search"
            value={searchText}
            width="92%"
            classes={StyleClass("bookOfMindOptionsSearch", {
                fontFamily: "Montaga",
                fontSize: "14px",
                padding: "4px 8px",
                lineHeight: "1.2",
                margin: "0",
            })}
        />
    );
}
